module.exports = __webpack_public_path__ + "fonts/Mukta-400-latin9.01968ef.woff2";